module.exports = __webpack_public_path__ + "3f16e137/img/splash-icon.07a7c465.svg";